var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('BaseHeadline',{attrs:{"icon":"mdi-account-hard-hat","showOnMobile":true,"breadcrumbs":_vm.breadcrumbsData,"showBreadcrumbsOnMobile":true}}),_c('DocumentsList',{attrs:{"documents":_vm.documents,"loading":_vm.loading},on:{"click":_vm.clickBtn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }